import React from "react";
import "./spinner.css";

export const LoadingSpinner = () => {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};


export const LoadingSmallSpinner = () => {
    return (
        <div className="loading-small-spinner">
            <div className="spinner-border">
                <span className="visually-hidden ">Loading...</span>
            </div>
        </div>
    );
};
